import axios from "axios";

const createFileUploads = async (destination, files) => {
  const fileData = new FormData();
  fileData.append("destination", destination);
  files.map((file) => fileData.append("files", file));
  const config = { headers: { "Content-Type": "multipart/form-data" } };

  return axios
    .post(`${process.env.REACT_APP_API_URL}/FileUploads`, fileData, config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const deleteFileUploads = async (destination, filename) => {
  const config = { data: { destination, filename } };

  return axios
    .delete(`${process.env.REACT_APP_API_URL}/FileUploads`, config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const getFileUploads = async (destination, filename) => {
  const fileData = { destination, filename };
  const config = { responseType: "blob" };

  return axios
    .post(`${process.env.REACT_APP_API_URL}/FileUploads/get`, fileData, config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      throw err.response?.data || err;
    });
};

const FileUploadsService = {
  createFileUploads,
  deleteFileUploads,
  getFileUploads
};

export default FileUploadsService;
